import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2'

const BarChart = (props) => {

    const [dataTemp, setDataTemp] = useState(props.data);

    useEffect(() => {
        setDataTemp(props.data);
    }, [props.data])

    return (
        <>


            <Bar
                data={{
                    // labels: ['T. Mercacias', 'T. Sevicios', 'T. Impuestos', 'T. Ventas'],
                    datasets: [
                        {
                            label: props.label,
                            data: dataTemp,
                            backgroundColor: [
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                            ],
                            borderColor: [
                                'rgba(75, 192, 192, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 1,
                        },
                    ],
                }}
                height={400}
                width={600}
                options={{
                    maintainAspectRatio: true,
                }}
            />

        </>
    )

}

export default (BarChart);